<script>
export default {
  data () {
    return {
      tabs: [],
      activeTab: null
    }
  },

  created () {
    this.tabs = this.$children;
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.href == selectedTab.href);
      });
    }
  }
}
</script>

<template lang="html">
  <div class="Tabs">
    <div class="Tabs-header u-mt4">
      <div class="l-wrap--medium">
        <ul v-if="tabs.length > 1" class="Tabs-menu">
          <li class="Tabs-menu-item" v-for="(tab, index) in tabs">
            <a class="Tabs-menu-link" :href="tab.href" :class="{ '-active': tab.isActive }" @click.prevent="selectTab(tab)">
              {{ tab.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// tabs.vue?32cfe96e